import React, { useEffect, useRef, useState } from 'react';
import { InputFieldLogin } from '../../FirstScreen/styled';
import { ErrorMsg, InputWrapper, LoginDesc, LoginForm } from '../styled';
import GetOtpButton from '../GetOtpButton';
import { fireLoginEvent } from '../../utils';
import TickAnimation from '../../../AddressPage/TickAnimation/TickAnimation';
import Theme from '../../../AddressPage/Theme';
import { removeCountryCode } from '../common';
import { setWebUserIdReact } from '../../../../Utils/commonUtils';

function EnterPhone(props) {
  const { mobileNumber, sendOtp, fromAddress } = props;
  const [errorText, showErrorText] = useState(null);
  const phoneInput = useRef();
  const [disableSendButton, setDisableSendButton] = useState(true);
  const [mobile, setMobile] = useState();
  const [maxLen, setMaxLen] = useState(13);

  const handleInputChange = (e) => {
    mobileNumber.current = removeCountryCode(e.target.value);
    setMobile(mobileNumber.current);
    if (mobileNumber.current.length === 10) {
      if (new RegExp('[6-9]{1}[0-9]{9}').test(e.target.value)) {
        fireLoginEvent('entered_contact_for_web_login');
        showErrorText(false);
        setDisableSendButton(false);
        setMaxLen(10);
      }
    } else if (mobileNumber.current.length == 0) {
      showErrorText(false);
      setDisableSendButton(true);
      setMaxLen(13);
    } else {
      showErrorText(true);
      setDisableSendButton(true);
      setMaxLen(13);
    }
  };

  // useEffect(() => {
  //     phoneInput?.current.focus();
  // }, []);

  const initialize = async () => {
    if (
      typeof window !== 'undefined' &&
      window?.__KP_LOGIN_SDK_INSTANCE__?.handleKpSSOButton &&
      window?.isKwikPassScriptLoaded
    ) {
      await window.__KP_LOGIN_SDK_INSTANCE__.handleKpSSOButton();
    }

    if (fromAddress) {
      router.beforePopState(() => {
        if (!JSON.parse(localStorage.getItem('guestPopupRemoved')))
          setShowGuestPopup(true);
        return true;
      });
    }
    localStorage.setItem('guestPopupRemoved', false);
    setWebUserIdReact();
  };

  useEffect(() => {
    initialize();
  }, []);

  return (
    <Theme>
      <LoginDesc>Login to track and manage your orders</LoginDesc>
      <LoginForm>
        <div
          id="kwikpass-sso-container"
          logo="https://pdp.gokwik.co/kwikpass/assets/icons/kwik_pass_logo.svg"
        ></div>
        <form onSubmit={(e) => e.preventDefault()}>
          Enter mobile no.*
          <InputWrapper>
            <InputFieldLogin
              redBorder={errorText}
              greenBorder={
                !errorText && errorText !== null && !disableSendButton
              }
            >
              <div className="countryCode">+91</div>
              <input
                type="tel"
                onChange={handleInputChange}
                maxLength={maxLen}
                placeholder="Enter mobile number"
                autoComplete="tel"
                value={mobile}
                autoFocus={false}
                //id="phone"
                ref={phoneInput}
              />
            </InputFieldLogin>
            {!errorText && errorText !== null && !disableSendButton ? (
              <TickAnimation />
            ) : null}
          </InputWrapper>
          {errorText ? (
            <ErrorMsg>Please enter valid mobile number</ErrorMsg>
          ) : null}
          <GetOtpButton
            sendOtp={sendOtp}
            disableSendButton={disableSendButton}
          />
        </form>
      </LoginForm>
    </Theme>
  );
}

export default EnterPhone;
